<template>
	<div class="resultados_tab report_theme_container" data-theme="resultados">
		<TabHeader
			class="mb-5"
			title="Estado de resultados"
			description="Visualiza el estado de tu negocio en un solo lugar."
			:filterPeriod="filterPeriod"
			:filterOptions="filterOptions"
			:endMonth="endMonth"
			:getNow="getNow"
			:compact="true"
			@update-filter-period="updateFilterPeriod"
			@update-end-month="updateEndMonth" />

		<!-- Table Section -->
		<div class="underHeader">
			<FinancialResultsTable
				class="mt-6"
				title="Estado de Resultados"
				:rows="tableRows"
				:headers="getHeadersTable"
				:isLoading="isLoading"
				:selectedPeriodRange="selectedPeriodRange"
				:periodOptions="periodOptions"
				:filterPeriod="filterPeriod"
				:expandedRows="expandedRows"
				@update-period="updateSelectedPeriodRange"
				@toggle-childs="changeViewTotalBills">
				<template #header-actions>
					<button class="action_btn mr-2">
						<ChartLine class="mr-1" style="width: 16px; height: 16px;" />
						Ver Gráfico
					</button>
				</template>
			</FinancialResultsTable>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { PERIOD_TYPES, FILTER_PERIOD_OPTIONS } from "../config/reportStructure";

import ChartLine from "@/components/svg/ChartLine.vue";
import TabHeader from "@/components/financialReports/TabHeader.vue";
import FinancialResultsTable from "@/components/financialReports/FinancialResultsTable.vue";

export default {
	name: "ResultadosTab",
	components: {
		TabHeader,
		ChartLine,
		FinancialResultsTable
	},
	data() {
		return {
			totalBillsExpanded: false,
			periodOptions: PERIOD_TYPES,
			filterOptions: FILTER_PERIOD_OPTIONS
		};
	},
	computed: {
		...mapState("reportsFilters", ["endMonth", "selectedPeriodRange"]),
		...mapState("financialReports", [
			"filterPeriod",
			"tableRowHeaders",
			"netSellsDetail",
			"maxCostsDetail",
			"maxExpensesDetail",
			"isLoading"
		]),
		...mapGetters("financialReports", {
			getHeadersTableFunc: "getHeadersTable"
		}),
		getHeadersTable() {
			return this.getHeadersTableFunc();
		},
		tableRows() {
			const headers = this.tableRowHeaders;
			return Object.entries(headers)
				.filter(([, row]) => row.isShowed !== false)
				.map(([key, row]) => ({ ...row, id: key }));
		},
		expandedRows() {
			return this.totalBillsExpanded ? ["gastos_totales"] : [];
		},
		getNow() {
			return moment().toDate();
		},
		// Firma reactiva consolidada — un solo trigger para fetch aunque
		// varios filtros cambien en la misma transacción.
		fetchSignature() {
			return [this.filterPeriod, this.endMonth, this.selectedPeriodRange].join("|");
		},
	},
	mounted() {
		this.fetchReportData();
	},
	methods: {
		...mapActions("financialReports", ["fetchReportData"]),
		...mapActions("reportsFilters", ["setPeriodRange"]),
		...mapMutations("reportsFilters", ["SET_END_MONTH"]),
		...mapMutations("financialReports", [
			"SET_FILTER_PERIOD",
			"TOGGLE_CHILD_ROWS"
		]),
		updateFilterPeriod(period) {
			this.SET_FILTER_PERIOD(period);
		},
		updateEndMonth(date) {
			this.SET_END_MONTH(date);
		},
		updateSelectedPeriodRange(range) {
			this.setPeriodRange(range);
		},
		// Único toggle expandible en Resultados; el evento del componente trae
		// rowId pero solo gastos_totales lo emite porque es la única fila con
		// hasChilds. Si en el futuro se agregan más, expandir a un Set por id.
		changeViewTotalBills(rowId) {
			if (rowId !== "gastos_totales") return;
			this.totalBillsExpanded = !this.totalBillsExpanded;
			this.TOGGLE_CHILD_ROWS(this.totalBillsExpanded);
		},
	},
	watch: {
		fetchSignature() {
			this.fetchReportData();
		},
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style.scss";

.resultados_tab {
	position: relative;
	padding-bottom: 40px;
	height: 100%;
}

// Header común vive en TabHeader.vue. Acá solo queda .action_btn que es
// específico del slot #header-actions de FinancialResultsTable (botón
// "Ver Gráfico" inyectado por este tab).

.action_btn {
	background: var(--report-bg);
	border: 1px solid var(--report-border);
	border-radius: 8px;
	padding: 6px 12px;
	font-size: 14px;
	font-weight: 500;
	color: var(--report-text-muted);
	display: flex;
	align-items: center;
	cursor: pointer;

	&:hover {
		background: var(--report-surface);
	}
}

.has-gap-cards {
	gap: 16px;
}
</style>
